import PublisherActions from '../../../../actions/PublisherActions';
import RegionsActions from '../../../../actions/RegionsActions';
import store from '../../../../stores/redux';
import config from '../../../../config';
import query from '../../../../helpers/query';
import { getRegionIds } from '../helpers';

let lastGoalEntriesSignature = null;
let pendingTimeout = null;

export const actions = {
    update(state) {
        const params = {
            ...query.parseToSend(state),
            offer_goal_q: state.searchString
        };

        const signature = JSON.stringify(params);
        if (signature === lastGoalEntriesSignature && !pendingTimeout) {
            return;
        }
        if (pendingTimeout) {
            clearTimeout(pendingTimeout);
            pendingTimeout = null;
        }

        pendingTimeout = setTimeout(() => {
            pendingTimeout = null;
            lastGoalEntriesSignature = signature;

            PublisherActions.getGoalEntries(params, () => {
                const goalEntries = store.getState().goalEntries.list;
                if (!Array.isArray(goalEntries) || !goalEntries.length) {
                    return;
                }

                const regionIds = getRegionIds(goalEntries);

                if (regionIds) {
                    RegionsActions.searchRegions({
                        ids: regionIds,
                        count: config.itemsCountPerPage
                    });
                }
            });
        }, 0);
    }
};
